import { registerMicroApps, removeMicroApps, start } from '@ice/stark'
import { event as IceEvent } from '@ice/stark-data'
import { updateAppConfig } from '@ice/stark/lib/apps'
import { APP_NAMES, ICE_EVENT_NAMES, ICE_STORE_KEYS } from './constants'
import { PAY_CENTER_PATH, setForceReloadLeyoPay } from './config'
import router from '@/router'
import { useMicroAppConfigStoreWithoutSetup } from '@/store/modules/microAppConfig'
import { useUserStoreWithoutSetup } from '@/store/modules/user'

let microAppStarted = false
/** 启动微应用 */
function startMicroApps() {
  if (microAppStarted) return
  const microAppConfig = useMicroAppConfigStoreWithoutSetup()
  start({
    // prefetch: true,
    onAppEnter() {
      microAppConfig.setMicroAppVisibility(true)
    },
    onAppLeave() {
      microAppConfig.setMicroAppVisibility(false)
    },
    shouldAssetsRemove() {
      return false
    }
  })
  microAppStarted = true
}
/**
 * 注册并管理微应用
 */
export const initMicroApps = () => {
  const containerId = 'micro-app-container'
  const microAppConfigStore = useMicroAppConfigStoreWithoutSetup()

  const getContainer = () => document.getElementById(containerId)
  const appConfigs: any[] = []

  // --- 数据中台 (DataCenter) ---
  if (microAppConfigStore.isRegisteredApp(APP_NAMES.DATA_CENTER)) {
    updateAppConfig(APP_NAMES.DATA_CENTER, { container: getContainer() })
  } else {
    appConfigs.push({
      name: APP_NAMES.DATA_CENTER,
      activePath: ['/variety/product-info/'],
      exact: true,
      title: APP_NAMES.DATA_CENTER,
      container: getContainer(),
      entry: import.meta.env.VITE_DATA_CENTER,
      props: { fromApp: 'SupplierPlatform' }
    })
  }

  // --- 结算系统 (PayCenter) ---
  if (microAppConfigStore.isRegisteredApp(APP_NAMES.PAY_CENTER)) {
    updateAppConfig(APP_NAMES.PAY_CENTER, { container: getContainer() })
  } else {
    appConfigs.push({
      name: APP_NAMES.PAY_CENTER,
      activePath: [PAY_CENTER_PATH],
      exact: true,
      title: APP_NAMES.PAY_CENTER,
      container: getContainer(),
      entry: import.meta.env.VITE_PAY_CENTER,
      cached: true, // 同一子应用内路由切换时不卸载资源，避免重复 mount/unmount（见 ice-lab/icestark#738）
      props: {
        fromApp: 'SupplierPlatform',
        userType: 'SUPPLIER',
        forceReloadKey: ICE_STORE_KEYS.FORCE_RELOAD_LEYO_PAY
      }
    })

    // 注册刷新事件监听
    // 重载用户信息，并且刷新页面
    IceEvent.on(ICE_EVENT_NAMES.RELOAD_APP_LEYO_PAY_CENTER, async () => {
      setForceReloadLeyoPay(true)
      const userStore = useUserStoreWithoutSetup()
      await userStore.refreshMenuAndReload()
    })

    IceEvent.on(ICE_EVENT_NAMES.ROUTER_CHANGE_LEYO_PAY_CENTER, async (payload: any) => {
      const { path, fullPath } = payload
      const currentRoute = router.currentRoute.value
      if (currentRoute.path === PAY_CENTER_PATH) {
        const paycenterRoute = currentRoute.matched?.find((item) => item.path === PAY_CENTER_PATH)
        if (!paycenterRoute) return
        const mathedRoute = paycenterRoute.children.find((item) => {
          const itemPath = item.path.split('#')[1]
          return itemPath === path
        })
        if (!mathedRoute) return
        const resFullPath = `${PAY_CENTER_PATH}#${fullPath}`
        router.push(resFullPath)
      }
    })
  }

  // 执行注册
  if (appConfigs.length > 0) {
    registerMicroApps(appConfigs)
    appConfigs.forEach((app) => microAppConfigStore.registerApp(app.name))
  }
  if (!microAppStarted && getContainer()) {
    startMicroApps()
  }
}

/**
 * 移除指定微应用
 */
export const disposeMicroApps = (apps: APP_NAMES[]) => {
  const microAppConfigStore = useMicroAppConfigStoreWithoutSetup()
  removeMicroApps(apps)
  apps.forEach((app) => microAppConfigStore.unregisterApp(app))
}
